import React from 'react';
import HeaderNotifications from '../../components/header/HeaderNotifications';
import HeaderAccountMenu from '../../components/header/HeaderAccountMenu';

const SidebarBottomControls = ({
  isNotificationsDrawerOpen,
  onToggleNotificationsDrawer,
  userNavigation,
  username,
  lastName,
  workspaceName,
  onSignOut,
  layout = 'column'
}) => {
  const isRow = layout === 'row';

  return (
    <div className={`flex ${isRow ? 'flex-row items-center gap-3 px-2' : 'flex-col items-center gap-3'}`}>
      <HeaderNotifications
        variant="sidebar"
        isOpen={isNotificationsDrawerOpen}
        onToggle={onToggleNotificationsDrawer}
      />
      <HeaderAccountMenu
        variant="sidebar"
        userNavigation={userNavigation}
        username={username}
        lastName={lastName}
        workspaceName={workspaceName}
        onSignOut={onSignOut}
      />
    </div>
  );
};

export default SidebarBottomControls;
